import { AuthMethods } from "../consts/auth";
import { BootAuthResponse } from "../types";

export const getUserToken = (_authBoot: BootAuthResponse, _authMethod: AuthMethods, userToken: string): string => {
    // Currently a pass-through. Previously read `featureFlagService.isEnabled`
    // and `authBoot.integration.isProfilesEnabled` to optionally suffix the
    // token with a profile name, but the result was unused. Calling
    // `featureFlagService` server-side would also touch a module-level
    // singleton (cross-request bleed risk), so the singleton dependency is
    // intentionally removed.
    return userToken;
};
